import axios from "./axios";
import { handleApiError } from "./main";

export type PermissionType = {
    entity: string,
    detail: string,
    identifier: string,
    permissions: string[],
}

export type PermissionConfigType = {
    uuid: string,
    base: string,
    detail?: string,
    inheritance: string,
    inheritanceDetail?: string,
    create: boolean,
    read: boolean,
    write: boolean,
    delete: boolean,
    assign: boolean,
    unassign: boolean,
    role: {
        uuid: string,
        name: string,
        abbreviation: string,
    }
}

export const fetchPermissions = async (entity: string, identifier: string) => {
    console.log(`Fetching permissions for ${entity} @ ${identifier} ...`)
    const permissions = await axios
        .get<PermissionType>(`/ScoregBackend/public/permissions/${entity}/${identifier}`)
        .then((r) => r.data)
        .catch((err) => {
            throw handleApiError('permission', identifier, err);
        })

    return permissions
}

export const fetchDetailPermissions = async (entity: string, identifier: string, details: string[]) => {
    if (!identifier) {
        return []
    }
    console.log(`Fetching detail permissions for ${entity} @ ${identifier}  ...`)
    const permissions = await axios
        .get<PermissionType[]>(`/ScoregBackend/public/permissions/${entity}/${identifier}/${encodeURI(details.join(','))}`)
        .then((r) => r.data)
        .catch((err) => {
            throw handleApiError('permission', identifier, err);
        })

    return permissions
}

export const fetchListPermissions = async (list: string[]) => {
    console.log(`Fetching list permissions for ${list} ...`)
    const permissions = await axios
        .get<PermissionType[]>(`/ScoregBackend/public/permissions/list/${list}`)
        .then((r) => r.data)
        .catch((err) => {
            throw handleApiError('permission', 'list', err);
        })

    return permissions
}

export const fetchReportPermissions = async (report: string[]) => {
    console.log(`Fetching report permissions for ${report} ...`)
    const permissions = await axios
        .get<PermissionType[]>(`/ScoregBackend/public/permissions/report/${report}`)
        .then((r) => r.data)
        .catch((err) => {
            throw handleApiError('permission', 'report', err);
        })

    return permissions
}

export const fetchChartPermissions = async (chart: string[]) => {
    console.log(`Fetching chart permissions for ${chart} ...`)
    const permissions = await axios
        .get<PermissionType[]>(`/ScoregBackend/public/permissions/chart/${chart}`)
        .then((r) => r.data)
        .catch((err) => {
            throw handleApiError('permission', 'chart', err);
        })

    return permissions
}

export const fetchPermissionConfig = async () => {
    console.log(`Fetching permission config ...`)
    const config = await axios
        .get<PermissionConfigType[]>(`/ScoregBackend/public/permissions/config`)
        .then((r) => r.data)
        .catch((err) => {
            throw handleApiError('permission', 'config', err);
        })
    return config
}